export const colorList = [
    { id: 1, colorS: '#8100ff', colorE: '#8969ff' },
    { id: 2, colorS: '#7800ff', colorE: '#00a2ff' },
    { id: 3, colorS: '#005aff', colorE: '#00d2ff' },
    { id: 4, colorS: '#039dff', colorE: '#1ce7ff' },
    { id: 5, colorS: '#1dd36a', colorE: '#61fff6' },
    { id: 6, colorS: '#fb6023', colorE: '#fdd96b' },
    { id: 7, colorS: '#ff6b44', colorE: '#f79f77' },
    { id: 8, colorS: '#ea415b', colorE: '#ff9197' },

    { id: 9, colorS: '#008AFF', colorE: '#00355E' },
    { id: 10, colorS: '#00A8CC', colorE: '#00355E' },
    { id: 11, colorS: '#00CCAD', colorE: '#00355E' },
    { id: 12, colorS: '#FAA24C', colorE: '#00355E' },
    { id: 13, colorS: '#DF6969', colorE: '#00355E' },

]
